module.exports = __webpack_public_path__ + "static/img/nav_acount.485ce22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav_acount.svg
// module id = csyk
// module chunks = 1